"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
var str = String.prototype;
str.format = function (...args) {
    var me = this.toString();
    for (var i = 0; i < args.length; i++) {
        me = me.replaceAll("{" + i + "}", args[i] || "");
    }
    return me;
};
str.isEmail = function () {
    var regex = /^[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?$/;
    return regex.test(this);
};
str.isImgExtension = function () {
    switch (this.toString().toLowerCase()) {
        case "jpg":
        case "png":
        case "gif":
            return true;
        default:
            return false;
    }
};
str.replaceAll = function (search, replace) {
    return this.split(search).join(replace);
};
str.splitOnLastInstanceOf = function (splitter) {
    var array = [this];
    var index = this.lastIndexOf(splitter);
    if (index != -1) {
        var begin = this.substring(0, index);
        var end = this.substring(index + splitter.length);
        array = [begin, end];
    }
    return array;
};
str.getAllAfterLastInstanceOf = function (splitter) {
    return this.splitOnLastInstanceOf(splitter)[1] || this;
};
str.getStringAfterLastIndexOf = function (splitter) {
    var lastIndex = this.lastIndexOf(splitter);
    var newString = this.substr(lastIndex + 1);
    return newString;
};
str.toUpperCaseFirstLetter = function () {
    return this.charAt(0).toUpperCase() + this.slice(1);
};
str.toLowerCaseFirstLetter = function () {
    return this.charAt(0).toLowerCase() + this.slice(1);
};
str.contains = function (it) {
    return this.indexOf(it) != -1;
};
str.startsWith =
    str.startsWith ||
        function (searchString, position) {
            return _.startsWith(this, searchString, position);
        };
//# sourceMappingURL=string.extensions.js.map